import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AppConfigService } from 'app/services/app-config.service';

@Directive({
  selector: 'img[appImageFallback]',
  standalone: true,
  host: {
    '(error)': 'onError()'
  }
})
export class ImageFallbackDirective {
  @Input() fallbackSrc = 'assets/images/logo/logo.svg';

  private triedFallback = false;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2,
    private config : AppConfigService
  ) {
    this.fallbackSrc = config.default;
  }

  onError(): void {
    const img = this.el.nativeElement;

    if (this.triedFallback) {
      return;
    }

    this.triedFallback = true;
    this.renderer.setAttribute(img, 'src', this.fallbackSrc);
  }
}